<template>
  <div class='blister-info'>
    <span class='name'>{{blister.name }}</span>
    <span>{{blister.width }}</span>
    <span>✕</span>
    <span>{{blister.length }}</span>
    <span>✕</span>
    <span>{{blister.height }}</span>
  </div>
</template>

<script>
export default {
  name: 'BlisterInfo',
  props: {
    blister: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.blister-info {
  display: flex;
  align-items: center;
  gap: 15px;

  .name {
    font-weight: bold;
  }
}
</style>